import {
  Alert,
  BodyText,
  Flex,
  Heading,
  InlineLink,
  Strong,
} from '@utilitywarehouse/hearth-react';
import { TickSmallIcon } from '@utilitywarehouse/hearth-react-icons';
import { useLocation } from 'react-router-dom';

import { EXTERNAL_LINKS } from '@constants/externalLinks';
import { DEPOSIT_AMOUNT } from '@constants/queryParams';
import { type BroadbandAppointment } from '@generated/gql/graphql';

import './styles.scss';

interface NextStepsProps {
  accountNumber?: Nullable<string>;
  broadbandAppointment?: Nullable<BroadbandAppointment>;
}

const NextSteps = ({ accountNumber, broadbandAppointment }: NextStepsProps) => {
  const location = useLocation();
  const paidDepositAmount = location.state?.[DEPOSIT_AMOUNT];

  return (
    <Flex direction="column" spacing="xl">
      {accountNumber && (
        <BodyText data-testid="thankyou-account-number">
          Account number: <Strong>{accountNumber}</Strong>
        </BodyText>
      )}
      {paidDepositAmount && (
        <Alert colorScheme="positive" data-testid="thankYou__successDeposit">
          Thank you - your deposit payment of {paidDepositAmount} was
          successful.
        </Alert>
      )}
      <Flex direction="column" spacing="lg">
        <Heading as="h2" size="lg">
          What you need to do next
        </Heading>
        <Flex asChild direction="column" spacing="lg">
          <ul className="thankYou__steps-list">
            <Flex asChild spacing="sm">
              <li>
                <TickSmallIcon />
                <BodyText>
                  Verify your email address by clicking the link in the email we
                  just sent you, so you can access your account online and in
                  the UW app. Please check your spam or junk folder for this.
                </BodyText>
              </li>
            </Flex>
            {!!broadbandAppointment && (
              <Flex asChild spacing="sm">
                <li>
                  <TickSmallIcon />
                  <BodyText>
                    Look out for an email and text where we'll confirm your
                    broadband installation appointment date and time.
                  </BodyText>
                </li>
              </Flex>
            )}
            <Flex asChild spacing="sm">
              <li>
                <TickSmallIcon />
                <BodyText>
                  <InlineLink
                    href={EXTERNAL_LINKS.appDownloadLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    hideOpenIcon
                  >
                    Download the UW app
                  </InlineLink>{' '}
                  to track your switch live and manage your chosen services.
                </BodyText>
              </li>
            </Flex>
          </ul>
        </Flex>
      </Flex>
    </Flex>
  );
};

export { NextSteps };
export type { NextStepsProps };
